<template>
    <b-modal ref="modal-preview" size="md" :title="colorSizeModal.colorTitle + colorSizeModal.sizeTitle + '選択'" id="PT110_colorSizeModal" v-model="showFlg" :hide-footer="true">
        <b-container fluid>
            <div class="colorSizeImg">
                <!--商品画像-->
                <img class="mb08 " :src="colorSizeModal.csitemimg" alt="product.THUMBNAIL_DETAIL" @error="getErrImage">
            </div>
            <div class="pt110_colorSize">
                <dl class="input-txt-colorSize num06 row">
                    <span hidden id="colorSize_lbl">{{$t('pt120.labels.colorSize')}}</span>
                    <dt>{{colorSizeModal.colorTitle}}<br/>/{{colorSizeModal.sizeTitle}}</dt>
                    <dd class="csSelect">
                        <select class="ColorSizeSelect" v-model="sItemNo" :name="'colorSize'">
                            <option v-for="cs in colorSizeModal.colSizList" :key="cs.KEY" :value="cs.KEY">{{cs.VALUE}}</option>
                        </select>
                    </dd>
                </dl>
                <div class="col-md-12 col-sm-12 text-center pt-2 pb-2 selectCororSize">
                    <b-btn size="sm" variant="success-colorSize" @click="setValue">
                        <!-- 選択する -->
                        {{$t('cc212.buttons.select')}}
                    </b-btn>
                </div>
            </div>
            <div class="d-flex justify-content-center selectCororSize">
                <template class="col-sm-12 text-center">
                    <b-btn size="sm" class="w-4 text-center" variant="secondary-colorSize" @click="showFlg = false">
                        <!-- 閉じる -->
                        {{$t('common.buttons.close')}}
                    </b-btn>
                </template>
            </div>
        </b-container>
    </b-modal>
</template>
<script>
import common from 'assets/js/common';
import EventBus from "assets/js/eventBus";
import Loading from 'vue-loading-overlay';

export default {
    name: "PT110_colorSizeModal",
    components: {
        Loading
    },
    props: {
        isChildModal: {
            type: Boolean,
            default: false
        },
        data: {
            colorSizeModal:null,
        },
        index:{
        }
    },
    data: function() {
        return {
            colorSizeModal:{},
            showFlg: true,
            sItemNo: null,
        };
    },
    mounted() {
        var _this = this;
        _this.colorSizeModal = _this.data;
        // get error from datatable
        EventBus.$on("error-list", errorList => {
            _this.isDisplay = false;
            var listId = common.excuteValidation(errorList, 'Cc');
            _this.listIdErr.push.apply(_this.listIdErr, listId) ;
        });
        //Reload data request model
        EventBus.$on('reset-page', function () {
        });
        // receive status loading  
        EventBus.$on('is-loading', function (data) {
            _this.isLoading = data;
        });
    },
    methods: {
        setValue:function(){
            var  _this = this;
            var sItemNo = _this.sItemNo;
            if (sItemNo == "" || sItemNo == undefined) {
                alert(_this.$i18n.t("common.messages.colorSizeCheck"));
                return;
            }
            var data = {
                sItemNo:sItemNo
            }
            this.$emit("set-addr-value", data);
            this.showFlg = false;
        },
        /**
         *  Exec close modal
         * @param {Any} evt, event close
         */
        handleCancel(evt){
            evt.preventDefault();
            this.showFlg = false;
        },
        /**
         * exec load url default when load main image is error
         * @param {Any} event, event exec error
         */
        getErrImage(event) {
            //get image default
            event.target.src = common.getImgDefault();
        },
    },
    /*
    * Forcus to input
    */
    updated: function(){
        common.setFocusCC();
    },
    created() {
        common.initFlagCC = true;
        //set status popup open
        common.isPopupShowFlg = true;
    },
   /*
    * Function watch
    */
    watch: {
        /*
        *  event close modal
        */
        showFlg() {
            this.$emit('modal-close', 'PT110_colorSizeModal');
        }
    },
    /*
    * destroy eventbus of page before close page
    */
    beforeDestroy: function () {
        EventBus.$off('error-list');
        EventBus.$off('is-loading');
    },
};
</script>